import IconUpgrade from "./icon-upgrade.svg?react";
import { Trans } from "react-i18next";

export default ({ action = "Upgrade", onClick }: { action?: string; onClick: any }) => {
  return (
    <div className="text-[12px] text-kds-accent flex items-center cursor-pointer group" onClick={onClick}>
      <div className="group-hover:underline">
        {action === "Upgrade" && <Trans>Upgrade</Trans>}
        {action === "Credits" && <Trans>Get More Credits</Trans>}
      </div>
      <IconUpgrade></IconUpgrade>
    </div>
  );
};
